angular.module('washesDashboard', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/washes-dashboard/washes-dashboard.module.js